module.exports = __webpack_public_path__ + "static/media/eswatini-shipping-map.524f5b9b.jpg";